import { get } from "@/utils";

export const GoogleSiteTag = {
  enable() {
    let script = document.createElement("script"); // NOSONAR
    script.type = "text/javascript";
    script.onload = function() {
      window.dataLayer = window.dataLayer || [];
      window.gtag = function() {
        window.dataLayer.push(arguments);
      };
    };
    script.src = "https://www.googletagmanager.com/gtag/js?id=AW-685925423";
    document.getElementsByTagName("head")[0].appendChild(script);
  },
  wait() {
    return !!window.gtag;
  }
};

export const GoogleAds = {
  enable() {
    // No se hace porque GoogleSiteTag ya lo hace
    return true;
  },
  wait() {
    return !!window.gtag;
  },
  init() {
    window.gtag("js", new Date());
    window.gtag("config", "AW-685925423");
  },
  consulta() {
    window.gtag("event", "conversion", {
      send_to: "AW-685925423/XekXCNjt9fQYEK_IiccC"
    });
  },
  ofertaEmprendedores(context) {
    /**
     * Si se genera una key, el usuario NO es cliente
     * Entonces puede avanzar con la contratacion
     */
    const key = get(context, "state.key", false);
    if (key) {
      window.gtag("event", "conversion", {
        send_to: "AW-685925423/yXPsCNPe84gZEK_IiccC"
      });
      return;
    }
    window.gtag("event", "conversion", {
      send_to: "AW-685925423/5I0jCKyM-fQYEK_IiccC"
    });
  }
};
